import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import NumberedCitationEditing from './numberedcitationediting';

export default class NumberedCitation extends Plugin {
  static get pluginName() {
    return 'NumberedCitation';
  }
  static get requires() {
    return [ NumberedCitationEditing ];
  }
}
